export default __webpack_public_path__ + "static/media/question.0723e1c7.svg";